import { COMPANY as company } from './company';
import { USER as user } from './user';

export const SETTINGS = {
  company,
  user
};
